export default "__VITE_ASSET__ef72c68f__"